import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const navLinks = [
  { label: "Home", href: "/" },
  { label: "Guides", href: "#guides" },
  { label: "Templates", href: "#resources" },
  { label: "Comparisons", href: "#comparison" },
  { label: "Safety", href: "#safety" },
  { label: "FAQ", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleCategoryClick = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-bold text-sm font-label">
              V
            </span>
            <span className="text-lg font-heading font-semibold text-foreground-900 whitespace-nowrap">
              Vigorbuy Spreadsheet
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm font-label text-foreground-700 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2.5 text-sm font-label font-medium bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Shopping Guide
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2.5 text-sm font-label font-medium border border-background-300/60 text-foreground-700 rounded-md hover:border-primary-300/60 hover:text-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-2xl`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-4 border-t border-background-200/70">
            <div className="flex flex-col gap-1 pt-3">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={() => setMobileOpen(false)}
                  className="px-4 py-2.5 text-sm font-label text-foreground-700 hover:bg-background-100 rounded-md transition-colors"
                >
                  {link.label}
                </a>
              ))}

              <div className="mx-4 mt-3 mb-1">
                <p className="text-xs font-label font-semibold text-foreground-500 uppercase tracking-wider mb-2">
                  Product Categories
                </p>
                <div className="grid grid-cols-2 gap-1">
                  {categories.map((cat) => (
                    <button
                      key={cat.name}
                      onClick={() => {
                        handleCategoryClick(cat.url);
                        setMobileOpen(false);
                      }}
                      className="px-3 py-2 text-xs font-label text-foreground-700 hover:bg-background-100 rounded-md text-left transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </button>
                  ))}
                </div>
              </div>

              <div className="flex flex-col gap-2 mx-4 mt-3">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-5 py-2.5 text-sm font-label font-medium bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors text-center cursor-pointer"
                >
                  Shopping Guide
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-5 py-2.5 text-sm font-label font-medium border border-background-300/60 text-foreground-700 rounded-md hover:border-primary-300/60 hover:text-primary-600 transition-all text-center cursor-pointer"
                >
                  Buy It Now
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}